// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3gu5O","header":"MergedInvoice_header__Fnhqr"};